import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import router from "../router";
import store from "../store";
import errorCode from "@/utils/errorCode";
import storage from "store";
import NProgress from "nprogress";
import appConfig from '@/config'

const request = axios.create({
  // API 请求的默认前缀
  baseURL: appConfig.BASE_API,
  timeout: 60000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
  NProgress.done();
  console.log("err" + error);
  let { message } = error;
  if (message === "Network Error") {
    message = "后端接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常";
  }
  // if ( error. )
  Message({
    type: "error",
    message: message,
    duration: 5 * 1000,
  });
  return Promise.reject(message);
};

// request interceptor
request.interceptors.request.use((config) => {
  NProgress.start();
  // const token = storage.get(LOGIN_TOKEN);
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // 处理params参数
  if (config.params) {
    const url =
      config.url +
      "?Source=PC&" +
      qs.stringify(config.params, { indices: false });
    config.params = {};
    config.url = url;
  }
  if (config.data) {
    config.data = config.data;
  }
  return config;
}, errorHandler);

request.interceptors.response.use((res) => {
  NProgress.done();
  // console.log(res)
  // 请求rul
  // 未设置状态码则默认成功状态
  const code = res.data.Code || 0;
  // 获取错误信息
  const msg = res.data.Message || errorCode[code] || errorCode["default"];

  // 二进制数据则直接返回,original==true 也直接返回
  if (
    res.request.responseType === "blob" ||
    res.request.responseType === "arraybuffer" ||
    res.config.original
  ) {
    return Promise.resolve(res.data);
  }
  if (code === 401) {
    Message({
      message: "登录状态已过期，请重新登录",
      type: "warning",
      onClose() {
        router.push("/login");
        store.dispatch("LOGIN_OUT");
      },
    });
  } else if (code === 500) {
    Message({
      message: msg,
      type: "error",
    });
    return Promise.reject(res);
  } else if (code !== 0) {
    Message({
      message: msg,
      type: "error",
    });
    return Promise.reject(res);
  } else {
    return Promise.resolve(res.data.Data);
  }
}, errorHandler);

export default request;
